




































import {Component, Mixins, Prop} from 'vue-property-decorator'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'

@Component
export default class GasbotFaqCard extends Mixins(MixinScreenSize) {
  @Prop({type: String, required: true}) question!: string
  @Prop({type: String, required: true}) answer!: string
  @Prop({type: Number || null, default: null}) activeIndex!: number | null
  @Prop({type: Number || null, default: null}) itemIndex!: number | null
  emailRegex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi

  get isItemActive() {
    return this.activeIndex === this.itemIndex
  }

  emailClass = (email: string) =>
    `<a class="text-ocean-green" href='mailto:${email}'>${email}</a>`

  answerFormatter(answer: string): string {
    let formatedAnswer = answer.replace('\n', '<br>')
    answer.match(this.emailRegex)?.forEach(email => {
      formatedAnswer = formatedAnswer.replace(email, this.emailClass(email))
    })
    return formatedAnswer
  }

  handleClick() {
    if (this.isItemActive) {
      this.$emit('update:itemIndex', null)
    } else {
      this.$emit('update:itemIndex', this.itemIndex)
    }
  }

  /**
   * The answer is injected with v-html, so a `/contact`-style link inside it is
   * a plain anchor that would reload the whole SPA. Intercept those and route
   * client-side; external links and mailto: are left to the browser.
   */
  handleAnswerClick(event: MouseEvent) {
    const anchor = (event.target as HTMLElement).closest('a')
    const href = anchor?.getAttribute('href')

    if (!href || !href.startsWith('/')) {
      return
    }

    event.preventDefault()

    if (this.$route.path !== href) {
      this.$router.push(href)
    }
  }
}
